import React from "react";
import { arrayOf, shape, string, object } from "prop-types";

const propTypes = {
  promos: arrayOf(
    shape({
      image: object,
      link: shape({
        text: string,
        href: string,
      }).isRequired,
    }),
  ),
};

const GlobalNavPromoList = (props) => {
  const { promos } = props;

  return (
    <section className="global-nav-promo-list">
      {promos &&
        promos.map((promo, i) => (
          <div key={i} className="global-nav-promo-list__item">
            {promo.image && (
              <img
                className="global-nav-promo-list__image"
                srcSet={promo.image.srcSet}
                alt={promo.image.alt}
                sizes="110px"
              />
            )}
            <div className="global-nav-promo-list__title">
              <a
                href={promo.link.href}
                hrefLang={promo.link.lang || null}
                lang={promo.link.lang || null}
                className="gloval-nav-promo-list__link link"
                data-gtm-element="global nav promo"
                data-gtm-link={promo.link.href}
                data-gtm-text={promo.link.text}
              >
                {promo.link.text}
              </a>
            </div>
          </div>
        ))}
    </section>
  );
};
GlobalNavPromoList.propTypes = propTypes;
export default GlobalNavPromoList;
